import React, { PropsWithChildren, useEffect } from "react"

import { GIT_HASH, POSTHOG_KEY } from "./env"
import { isProduction } from "./utils/utils"

export function AnalyticsProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    if (!isProduction) {
      console.log("Telemetry skipped")
      return
    }

    import("posthog-js")
      .then((x) => x.default)
      .then((posthog) => {
        if (!POSTHOG_KEY) {
          console.error(new Error("Posthog token missing"))
          return
        }

        // if (window.location.toString().includes("localhost")) {
        //   posthog.debug()
        // }

        posthog.init(POSTHOG_KEY, {
          api_host: "https://telemetry.privatefolio.app",
          person_profiles: "always",
          ui_host: "https://eu.posthog.com",
        })

        posthog.register({
          gitHash: GIT_HASH,
          variant: "homepage",
        })

        console.log("Telemetry enabled")
      })
  }, [])

  return <>{children}</>
}
